// **** import modules ****
import app, { vuwer, csl } from "@@assets/scripts/common";
import inView from "@@assets/scripts/inViewObserver";
import "@@assets/klass/VuwSlider";
import "@@components/pageNav";
import "./pageHeader/_index";
import "./maintenance/_index";
import "./custom/_index";
import "./alignment/_index";

// **** process ****
vuwer.get("pageMain").setProp({
	onReady($self) {
		if(!$self) {
			return false;
		}
		
		$self.children(".section").each((i, elm) => {
			inView.addTarget(elm, ($elm, isIntersecting) => {
				const key = $elm.attr("data-section");
				if(isIntersecting) {
					csl.log.orange(key, "in view");
				} else {
					csl.log.gray(key, "out of view");
				}
			});
		});
	}
});

app.onReady((...args) => {
	csl.log.orange(`${app.pageName} onReady`, ...args);
});

app.exec();
